/**
 * Response validation utilities
 * 
 * Shared utilities for validating HTTP responses to prevent
 * parsing HTML error pages as JSON.
 */

/**
 * Validates that a response has JSON content type.
 * Throws an error with detailed diagnostics if the response is not JSON.
 * 
 * @param response - The fetch Response object to validate
 * @throws Error if the response does not have JSON content-type
 */
export async function validateJsonResponse(response: Response): Promise<void> {
  const contentType = response.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) {
    // Response is not JSON (likely HTML error page)
    // Provide detailed error message with body preview for debugging
    let bodyPreview = '';
    try {
      const text = await response.clone().text();
      bodyPreview = text.slice(0, 120); // First 120 chars
    } catch {
      bodyPreview = '[Could not read response body]';
    }
    
    throw new Error(
      `Expected JSON from ${response.url}, got ${contentType || 'no content-type'} (status ${response.status}). Body: ${bodyPreview}`
    );
  }
}
